const themeConfig = {
    token: {
        colorPrimary: "#131517",
        colorInfo: "#131517"
    },
    components: {
        Button: {
            defaultShadow: false,
            primaryShadow: false,
            fontWeight: 600,
            defaultBg: "rgb(223,224,225)",
            defaultColor: "rgb(89,92,92)",
            defaultBorderColor: "rgb(223,224,225)"
        },
        Tabs: {
            colorText: "#969498"
        },
        Table: {
            padding: 8
        },
        
    }
}

export default themeConfig;